// Static content for the Roam Around UAE landing page

export const CONTACT = {
  email: "hi@roamarounduae.com",
  phone: "+971558228669",
  phoneDisplay: "+971 55 822 8669",
  whatsapp: "971558228669",
  domain: "roamarounduae.com",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=61591870048928",
  instagram: "https://www.instagram.com/roamarounduae?igsh=cXlhY2d5aDZpYnpo",
  whatsapp: "https://wa.me/971558228669",
};

export const NAV_LINKS = [
  { label: "The Idea", href: "#about" },
  { label: "Why Us", href: "#difference" },
  { label: "Experiences", href: "#experiences" },
  { label: "Design My Trip", href: "#contact" },
];

export const MARQUEE_ITEMS = [
  "Local UAE Experts",
  "Personalized Itineraries",
  "Handpicked Hotels",
  "Private Transfers",
  "24×7 Support",
];

export const DIFFERENTIATORS = [
  {
    icon: "Compass",
    title: "Local UAE Experts",
    body: "Born-and-raised guidance from people who know the UAE beyond the guidebook — the quiet gems and the grand icons alike.",
  },
  {
    icon: "PenTool",
    title: "Personalized Itineraries",
    body: "No two travellers are the same. Every day is composed around your interests, pace, budget and travel style.",
  },
  {
    icon: "BedDouble",
    title: "Handpicked Hotels",
    body: "From desert retreats to skyline suites — only stays we would personally recommend to our closest friends.",
  },
  {
    icon: "Car",
    title: "Private Transfers",
    body: "Seamless, chauffeured movement between every experience. You simply arrive; we handle the rest.",
  },
  {
    icon: "Headphones",
    title: "24×7 Support",
    body: "A dedicated designer on call throughout your journey. Wherever you are, we are one message away.",
  },
];

export const EXPERIENCES = [
  {
    title: "Golden Hour Desert",
    tag: "Al Marmoom · Liwa",
    image:
      "https://images.unsplash.com/photo-1580051859262-017717989ae8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB1YWUlMjBkZXNlcnQlMjBzdW5zZXR8ZW58MHx8fHwxNzgzNjg5MDM4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Skyline Icons",
    tag: "Dubai · Burj Al Arab",
    image:
      "https://images.unsplash.com/photo-1518684079-3c830dcef090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMGx1eHVyeSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2ODkwMzh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Living Heritage",
    tag: "Abu Dhabi · Al Fahidi",
    image:
      "https://images.unsplash.com/photo-1630255452925-41c35e9313bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxhcmFiaWMlMjB0cmFkaXRpb25hbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2ODkwMzl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Artisan Details",
    tag: "Souks · Old Town",
    image:
      "https://images.unsplash.com/photo-1550697318-929498858774?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxhcmFiaWMlMjB0cmFkaXRpb25hbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2ODkwMzl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1580051859262-017717989ae8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB1YWUlMjBkZXNlcnQlMjBzdW5zZXR8ZW58MHx8fHwxNzgzNjg5MDM4fDA&ixlib=rb-4.1.0&q=85";

export const ARCH_IMAGE =
  "https://images.unsplash.com/photo-1630255452925-41c35e9313bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxhcmFiaWMlMjB0cmFkaXRpb25hbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2ODkwMzl8MA&ixlib=rb-4.1.0&q=85";
